import React, { useMemo } from 'react'
import { useLocalization } from '@/hooks/localization'
import { PropertyRenderer } from '@/components/changeRequests'
import { Column, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'

export const BankDealsHistory = React.memo(function BankDealsHistory ({ dataSource }) {
  const { localize } = useLocalization()
  const defaultSort = useMemo(() => ([{ field: 'validFrom', dir: 'desc' }]), [])
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.BankDealsHistory}>
      <PropertyRenderer name='bankDealsHistory' inputType='grid' dataSource={dataSource} readonly defaultSort={defaultSort}>
        <Column field='bankName' title={localize('Common.Name')} />
        <Column field='bankLatinName' title={localize('Common.LatinName')} />
        <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
        <Column field='validUntil' title={localize('Common.ValidTo')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
        <Column field='changeNumber' title={localize('Common.ChangeNumber')} />
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})

export const CompanyDealsHistory = React.memo(function CompanyDealsHistory ({ dataSource }) {
  const { localize } = useLocalization()
  const defaultSort = useMemo(() => ([{ field: 'validFrom', dir: 'desc' }]), [])
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.BankDealsHistory}>
      <PropertyRenderer name='companyDealsHistory' inputType='grid' dataSource={dataSource} readonly defaultSort={defaultSort}>
        <Column field='companyName' title={localize('Common.Name')} />
        <Column field='companyLatinName' title={localize('Common.LatinName')} />
        <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
        <Column field='validUntil' title={localize('Common.ValidTo')} filter='date' filterCell={DateFilterCell} cell={DateCell} />
        <Column field='changeNumber' title={localize('Common.ChangeNumber')} />
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/bankDealsHistory.js